import * as yup from 'yup';
import { passwordPolicies } from './auth-service';
import { ERROR_MESSAGES, REGEXES } from './sign-up/sign-up.constants';
import {
    validateContainsLetter,
    validateFullName,
    validateNotEmail,
    validateNotURL,
    validatePhoneNumber,
} from './sign-up/sign-up.validation.utils';

const regexMap = {
    RequireNumbers: REGEXES.REQUIRE_NUMBERS,
    RequireLowercase: REGEXES.REQUIRE_LOWERCASE,
    RequireUppercase: REGEXES.REQUIRE_UPPERCASE,
    RequireSymbols: REGEXES.REQUIRE_SYMBOLS,
};

export const fullNameSchema = yup
    .string()
    .test('isValidFullName', ERROR_MESSAGES.INVALID_FULL_NAME, validateFullName)
    .test('containsLetter', ERROR_MESSAGES.INVALID_INPUT_DOES_NOT_CONTAINS_LETTER,
        validateContainsLetter)
    .test('isNotURL', ERROR_MESSAGES.INVALID_INPUT_URL, validateNotURL)
    .test('isNotEmail', ERROR_MESSAGES.INVALID_INPUT_EMAIL, validateNotEmail)
    .required(ERROR_MESSAGES.REQUIRED_NAME);

export const phoneSchema = yup
    .string()
    .test('phone', ERROR_MESSAGES.INVALID_PHONE, validatePhoneNumber)
    .required(ERROR_MESSAGES.REQUIRED_PHONE);

export const companyNameSchema = yup
    .string()
    .required(ERROR_MESSAGES.REQUIRED_COMPANY_NAME)
    .test('isNotURL', ERROR_MESSAGES.INVALID_INPUT_URL, validateNotURL)
    .test('isNotEmail', ERROR_MESSAGES.INVALID_INPUT_EMAIL, validateNotEmail)
    .test('containsLetter', ERROR_MESSAGES.INVALID_INPUT_DOES_NOT_CONTAINS_LETTER,
        validateContainsLetter);

export const employeePositionSchema = yup
    .string()
    .nullable()
    .required(ERROR_MESSAGES.REQUIRED_EMPLOYEE_POSITION);

export const companySectorSchema = yup
    .string()
    .nullable()
    .required(ERROR_MESSAGES.REQUIRED_COMPANY_SECTOR);

export const companySizeSchema = yup
    .string()
    .nullable()
    .required(ERROR_MESSAGES.REQUIRED_COMPANY_SIZE);

export const passwordSchema = async () => {
    const policy = await passwordPolicies();
    const regex = Object
        .entries(regexMap)
        .filter(([key]) => !!policy[key])
        .map(([, value]) => value)
        .join('');

    return yup
        .string()
        .test('password', ERROR_MESSAGES.INVALID_PASSWORD, password => new RegExp(regex).test(password))
        .min(policy.MinimumLength, ERROR_MESSAGES.INVALID_PASSWORD_LENGTH)
        .required(ERROR_MESSAGES.REQUIRED_PASSWORD);
};

export const confirmPasswordSchema = yup
    .string()
    .oneOf([yup.ref('password'), null, ''], ERROR_MESSAGES.PASSWORDS_DONT_MATCH)
    .required(ERROR_MESSAGES.REQUIRED_PASSWORD_CONF);
